module.exports = __webpack_public_path__ + "static/media/sabers_nft.5c0f79c4.png";